<div class="buscador-medicamentos">
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Buscar medicamento (min. 3 caracteres)</mat-label>
    <input
      matInput
      [(ngModel)]="searchTerm"
      (ngModelChange)="onSearch()"
      placeholder="Ej: ibuprofeno, amoxicilina..."
      autocomplete="off"
    />
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>

  <div *ngIf="buscando" class="spinner-container">
    <mat-progress-spinner
      diameter="30"
      mode="indeterminate"
    ></mat-progress-spinner>
    <span class="buscando-text">Buscando...</span>
  </div>

  <div *ngIf="resultados.length > 0" class="resultados-lista">
    <div *ngFor="let med of resultados" class="medicamento-grupo">
      <div class="medicamento-header">
        <strong>{{ med.name }}</strong>
        <span class="generico"> ({{ med.genericName }})</span>
      </div>
      <div class="presentaciones">
        <div
          *ngFor="let pres of med.presentations"
          class="presentacion-item"
          (click)="seleccionarPresentacion(med, pres)"
        >
          <mat-icon class="presentacion-icon">add_circle_outline</mat-icon>
          <span>{{ pres.name }} - {{ pres.quantity }} {{ pres.unit }}</span>
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="!buscando && resultados.length === 0 && searchTerm.trim().length >= 3"
    class="sin-resultados"
  >
    No se encontraron medicamentos
  </div>
</div>
